<template>
  <div class="controls">
    <div class="radio-group">
      <input
        type="radio"
        id="all"
        value="all"
        v-model="eventType"
      />
      <label for="all">All</label>

      <input
        type="radio"
        id="events"
        value="events"
        v-model="eventType"
      />
      <label for="events">Events</label>

      <input
        type="radio"
        id="exhibitions"
        value="exhibitions"
        v-model="eventType"
      />
      <label for="exhibitions">Exhibitions</label></div>
  </div>
</template>

<script>
export default {
  name: 'EventType',
  computed: {
    eventType: {
      get () {
        return this.$store.state.eventType
      },
      set (eventType) {
        this.$store.commit('SET_EVENT_TYPE', eventType)
        this.$store.dispatch('retrieveEvents')
      }
    }
  }
}
</script>
